/* eslint-disable */
import generateStoreSetters from '@/helpers/generateStoreSetters';
import { State, StateBarcode } from './state';

const state = new State();

const store = {
  namespaced: true,
  state,
  mutations: {
    ...generateStoreSetters(state),
    clearState: (stateBarcode: StateBarcode): void => {}
  },
  actions: {},
  modules: {},
  getters: {}
};

export { store as barcode };
